import React, { FC } from 'react'
import { OrderType } from 'types/checkout'
import { UserType } from 'types/user'
import {
  Card,
  CardInner,
  PrintDeliveryOrderHeader,
  PrintDeliveryOrderBody,
  PrintDeliveryOrderDescription,
  PrintOrderAmount,
  PrintOrderTotalQuantity,
} from 'components/Card'
import { HorizontalLine, Spacer } from 'components/Utility'
import { DeliveryAddress } from 'types/storeShipping'
import { parsePostalCodeWithHyphen } from 'lib/helper'

type Props = {
  deliveryAddress: DeliveryAddress
  isGift: boolean
  order: OrderType
  orderTimes: number
  scheduledDeliveryDate: string
  scheduledDeliveryTime: string
  senderName: string
  shippingNumber: string
  user?: UserType
}

const PrintDeliveryOrderCard: FC<Props> = (props) => {
  const {
    deliveryAddress,
    isGift,
    order,
    orderTimes,
    scheduledDeliveryDate,
    scheduledDeliveryTime,
    senderName,
    shippingNumber,
    user,
  } = props

  return (
    <Card isOutlined={true}>
      <CardInner>
        <PrintDeliveryOrderHeader
          scheduledDeliveryDate={scheduledDeliveryDate}
          scheduledDeliveryTime={scheduledDeliveryTime}
          shippingNumber={shippingNumber}
          order={order}
          orderTimes={orderTimes}
          tel={user ? user.tel : ''}
          username={user ? user.name : ''}
        />
        <HorizontalLine color={'grey04'} verticalMargin={8} />
        <PrintDeliveryOrderBody order={order} />
        <HorizontalLine color={'grey04'} verticalMargin={8} />
        <PrintOrderTotalQuantity items={order.items} />
        <PrintOrderAmount amount={order.amount} />
        {isGift && senderName !== '' && (
          <>
            <Spacer size={8} />
            <PrintDeliveryOrderDescription headline={'贈り主名'} description={senderName} />
          </>
        )}
        {deliveryAddress && (
          <>
            <Spacer size={8} />
            <PrintDeliveryOrderDescription
              headline={'お客さまの配送先情報'}
              description={`${deliveryAddress.name}様
              ${deliveryAddress.phone_number}
              ${parsePostalCodeWithHyphen(deliveryAddress.postal_code)}
              ${deliveryAddress.prefecture}${deliveryAddress.city}${deliveryAddress.street}${deliveryAddress.building}`}
            />
          </>
        )}
        {order.request !== '' && (
          <>
            <Spacer size={8} />
            <PrintDeliveryOrderDescription headline={'お客さまからのご要望'} description={order.request || ''} />
          </>
        )}
      </CardInner>
    </Card>
  )
}

export default PrintDeliveryOrderCard
